import { LOANREQUEST_DEFAULT_STATUS, TAX_CLASSIFICATIONS } from 'cpool-constants';

import type { SchemaLeadListSearch } from './features/leadList/schemas/route.schema';

export const GENDERS = {
    d: 'diverse',
    m: 'male',
    w: 'female',
} as const;
export const GENDERS_ENUM = ['d', 'm', 'w'] as const;

export const GENDERS_SHORTHAND = {
    d: 'd',
    m: 'm',
    w: 'f',
} as const;

export const ROLES = {
    accountant_manager: 'accountant_manager',
    admin: 'admin',
    adviser: 'adviser',
    corporation_director: 'corporation_director',
    division_leader: 'division_leader',
    email_manager: 'email_manager',
    team_leader: 'team_leader',
} as const;
export const ROLES_ENUM = [
    'accountant_manager',
    'admin',
    'adviser',
    'corporation_director',
    'division_leader',
    'email_manager',
    'team_leader',
] as const;
export const REPUDIATE_ROLES_ENUM = [
    '!accountant_manager',
    '!admin',
    '!adviser',
    '!division_leader',
    '!email_manager',
    '!team_leader',
] as const;

export const ORGANIZATIONS = {
    'kredit.de': 'kredit.de',
} as const;
export const ORGANIZATIONS_ENUM = ['kredit.de'] as const;

export const TEMPLATE_TYPES = {
    DIVISION_MAIL: 'DIVISION_MAIL',
    MAIL: 'MAIL',
    MAIL_FOOTER: 'MAIL_FOOTER',
    MAIL_HEADER: 'MAIL_HEADER',
    OFFER_MAIL: 'OFFER_MAIL',
    SIGNATURE: 'SIGNATURE',
    SYSTEM_MAIL: 'SYSTEM_MAIL',
} as const;

export const TIMINGS = {
    resubmission_count_refresh: 15000,
};

export const BUCKETS_ENUM = ['private-loan', 'individual-loan', 'special-loan', 'presale', 'bank'] as const;

export const EUROPACE_TRANSMIT_TYPES = {
    IMPORT: 'IMPORT',
    UPDATE: 'UPDATE',
} as const;

export type EUROPACE_TRANSMIT_TYPE = keyof typeof EUROPACE_TRANSMIT_TYPES;

// we need to add the NONE key to the TAX_CLASSIFICATIONS object
// so that the user can deselect the tax class
export const TAX_CLASSIFICATIONS_FRONTEND = {
    NONE: 'NONE',
    ...TAX_CLASSIFICATIONS,
} as const;

export const EUROPACE_PROCESS_EVENTS_DISCRIMINATORS = {
    OFFER: 'OFFER',
    PROCESS: 'PROCESS',
} as const;

export const PAGINATION = {
    ADVISER_LIST: {
        DEFAULT_PAGE_SIZE: 20,
        PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
        // teams up to this size skip pagination unless a page size is chosen
        PAGINATION_THRESHOLD: 20,
    },
    DEFAULT_PAGE: 1,
    ELLIPSIS: '•••',
    LEAD_LIST: {
        DEFAULT_PAGE_SIZE: 7,
        PAGE_SIZE_OPTIONS: [3, 7, 10, 25, 50, 100],
    },
    PARTNER_LIST: {
        DEFAULT_PAGE_SIZE: 20,
        PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
    },
    USER_LIST: {
        DEFAULT_PAGE_SIZE: 20,
        PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
    },
};

export const LEAD_LIST_FILTERS_STORAGE_KEY = 'lead-list-filters';

export const LEAD_LIST_DEFAULT_FILTERS = {
    adviser: [],
    bank: [],
    bucket: [],
    page: 1,
    pageSize: PAGINATION.LEAD_LIST.DEFAULT_PAGE_SIZE,
    partnerLevel: [],
    resubmission: false,
    status: LOANREQUEST_DEFAULT_STATUS.ALL,
    subStatus: [],
    tag: [],
} as const satisfies SchemaLeadListSearch;

export const KINDERGELD_HOEHE = 259;

export const RESUBMISSION_MINUTE_STEP = 5;
